import { RewardVault } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike, ZeroAddress } from "ethers";

export const FundVault = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  amount: bigint,
  rewardToken: AddressLike,
) => {
  return await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).fundVault(amount, { value: rewardToken == ZeroAddress ? amount : 0 });
};

export const CachebackVault = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  to: AddressLike,
) =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).cachebackVault(to);

export const FunderMethods = {
  FundVault,
  CachebackVault,
};

export default FunderMethods;
